import * as React from 'react';
import Modal from '@/presentation/modules/procedures/components/Modal/Modal';
import NotAvailable from '../Modals/NotAvailable';
import RequestExist from '../Modals/RequestExists';
import MyModal from '../Modals/MyModal';

interface ErrorProcedure {
  title: string;
  description: string;
}

interface ShowModalErrorInterface {
  error: ErrorProcedure | undefined;
  modals: any;
  closeModal: (modalName: string) => void;
  actionModal: (modalName: string) => void;
}

const ShowModalError = ({
  error,
  modals,
  closeModal,
  actionModal
}: ShowModalErrorInterface) => (
  <>
    <Modal
      show={modals.notAvailableModal}
      handleClose={() => closeModal('notAvailableModal')}
    >
      <NotAvailable handleClick={() => actionModal('notAvailableModal')} />
    </Modal>
    <Modal
      show={modals.alreadyExistsModal}
      handleClose={() => closeModal('alreadyExistsModal')}
    >
      <RequestExist handleClick={() => actionModal('alreadyExistsModal')} />
    </Modal>
    <MyModal
      show={modals.validationModal}
      data={{
        title: error?.title,
        description: error?.description
      }}
      handlerClick={() => actionModal('validationModal')}
      handlerClose={() => closeModal('validationModal')}
    />
  </>
);

export default ShowModalError;
